/* eslint-disable no-undef */
import axios from 'utils/axios';

const ADMIN_DONATION_BASE_PATH = '/admin/transaction';
const DONATION_REQUEST_TIMEOUT = 15000;

class DonationService {
  fetchDonationUsingId = (donationId) =>
    new Promise((resolve, reject) => {
      axios
        .get(`${ADMIN_DONATION_BASE_PATH}/donation/${donationId}`, {
          timeout: DONATION_REQUEST_TIMEOUT,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  fetchDonation = (page = 1, filters = {}) =>
    new Promise((resolve, reject) => {
      let filterQuery = '';

      for (const property in filters) {
        filterQuery =
          filterQuery + `&filter[${property}]=${filters[property] || ''}`;
      }

      axios
        .get(
          `${ADMIN_DONATION_BASE_PATH}/donation?page=${page}${filterQuery}`,
          {
            timeout: DONATION_REQUEST_TIMEOUT,
          },
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  verifiedDonation = (donation) =>
    new Promise((resolve, reject) => {
      axios
        .patch(`${ADMIN_DONATION_BASE_PATH}/verified/${donation.id}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  verifiedEDonation = (donation, params) =>
    new Promise((resolve, reject) => {
      axios
        .patch(
          `${ADMIN_DONATION_BASE_PATH}/verified/${donation.id}/edonation`,
          params,
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  cancelDonation = (donation) =>
    new Promise((resolve, reject) => {
      axios
        .patch(`${ADMIN_DONATION_BASE_PATH}/cancel/${donation.id}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  editDonationAmount = (id, params) =>
    new Promise((resolve, reject) => {
      axios
        .patch(`${ADMIN_DONATION_BASE_PATH}/amount/${id}`, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  editDonationDetailAmount = (id, detailId, params) =>
    new Promise((resolve, reject) => {
      axios
        .patch(`${ADMIN_DONATION_BASE_PATH}/${id}/detail/${detailId}`, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const donationService = new DonationService();

export default donationService;
